import { useState, useEffect, useMemo } from "react";
import TableCertificado from "../Components/TableCertificados";
import { formatDateTime, decodeJWT } from "../Components/jwtUtils";
import Api from "../Auth/Api";
import { pdf } from "@react-pdf/renderer";
import GerarCertificado from "../Components/GerarCertificado";
import { useCallback } from "react";
import { Modal, Toast } from "react-bootstrap";
import Tippy from "@tippyjs/react";
import { useAjustes } from "../Context/AjustesContext";
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';

function Certificados() {

    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivelUsuario = decodeJWT(token).nivel;
    const isAdminOrModerador = nivelUsuario === 'Moderador' || nivelUsuario === 'Administrador';
    const isGestor = nivelUsuario === 'Gestor';
    const isAdminModeradorOrGestor = isAdminOrModerador || isGestor;
    const navigate = useNavigate();
    
    const { ajustes } = useAjustes();
    const [selectedTipo, setSelectedTipo] = useState('favoritos');
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [showModalDetalhes, setShowModalDetalhes] = useState(false);
    const [certificadoSelecionado, setCertificadoSelecionado] = useState(null);
    const [statusExpiracao, setStatusExpiracao] = useState(null);
    const [certificadosStatus, setCertificadosStatus] = useState({});
    const [certificadosElegiveisPraEficacia, setCertificadosElegiveisPraEficacia] = useState({});
    const [showModalAvaliacaoEficacia, setShowModalAvaliacaoEficacia] = useState(false);
    const [avaliacaoEficaciaDetalhes, setAvaliacaoEficaciaDetalhes] = useState(null);

    const filterTipo = [
        { value: 'favoritos', label: 'Favoritos' },
        { value: 'todos', label: 'Todos' }
    ]

    //listar todos os cursos
    const [dataTodosCursos, setDataTodosCursos] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`/api/listar-todos-cursos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataTodosCursos(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token])

    // listar empresas
    const [dataEmpresas, setDataEmpresas] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-empresas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataEmpresas(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        if (isAdminOrModerador) {
            fetchData();
        }
    }, [token, isAdminOrModerador])

    // listar certificados
    const [dataCertificados, setDataCertificados] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`/api/listar-certificados/${selectedTipo}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    params: {
                        empresa: selectedEmpresa ? selectedEmpresa.value : undefined,
                    }
                });
                setDataCertificados(response.data);
            } catch (error) {
                setDataCertificados([]); // Se não tiver dados, limpa a lista
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, selectedTipo, selectedEmpresa])

    // Filtro para seleção por curso
    const [selectCurso, setSelectCurso] = useState(null);
    const [selectUnidade, setSelectUnidade] = useState(null);
    const FilterDataProvas = selectCurso ? dataCertificados.filter(item => item.idCurso === selectCurso) : dataCertificados;
    const FilterDataUnidade = selectUnidade ? FilterDataProvas.filter(item => item.unidade === selectUnidade) : FilterDataProvas;

    const unidades = useMemo(() => {
        const allUnidades = dataCertificados.map(item => item.unidade);
        const uniqueUnidades = [...new Set(allUnidades)];
        const unidadesFormatted = uniqueUnidades
            .filter(unidade => unidade && unidade.trim() !== '') // Filtrar valores vazios
            .map(unidade => ({ value: unidade, label: unidade }));
        return unidadesFormatted;
    }, [dataCertificados]);

    // Carregar status de expiração para todos os certificados listados
    useEffect(() => {
        if (dataCertificados.length === 0) return;
        
        // Criar um objeto onde as chaves são os IDs dos certificados e os valores são seus status
        const statusObj = {};
        const eficaciaObj = {};
        
        // Obter o ID do usuário logado
        const usuarioLogado = decodeJWT(token);
        const idUsuarioLogado = usuarioLogado.idUsuario;
        const nivelUsuarioLogado = usuarioLogado.nivel;
        
        dataCertificados.forEach(cert => {
            // Verificar se o certificado tem o objeto status
            if (cert && cert.status) {
                statusObj[cert.id] = cert.status;
                
                // Verificar se o certificado é elegível para avaliação de eficácia (90 dias após emissão E não expirado)
                const dataEmissao = new Date(cert.data);
                const hoje = new Date();
                const diffDias = Math.floor((hoje - dataEmissao) / (1000 * 60 * 60 * 24));
                
                // Verificar se o usuário logado é o gestor responsável pelo aluno (se for gestor)
                const isGestorResponsavel = nivelUsuarioLogado === 'Gestor' ? cert.gestor_responsavel === idUsuarioLogado : true;
                
                eficaciaObj[cert.id] = {
                    elegivel: 
                        diffDias >= 90 && 
                        !cert.status.expirado && 
                        !cert.status.arquivado && 
                        cert.avaliacao_eficacia !== 1 &&
                        isGestorResponsavel,
                    respondido: cert.avaliacao_eficacia === 1,
                    isGestorResponsavel: isGestorResponsavel
                };
            } else {
                console.warn(`Certificado ID ${cert.id} não possui informações de status`);
                // Criar um objeto status padrão para evitar erros
                statusObj[cert.id] = {
                    expirado: false,
                    arquivado: false,
                    prazo_validade: cert.prazo_validade || 0,
                    data_emissao: cert.data,
                    message: 'Informações de status não disponíveis'
                };
                
                eficaciaObj[cert.id] = {
                    elegivel: false,
                    respondido: cert.avaliacao_eficacia === 1,
                    isGestorResponsavel: false
                };
            }
        });
        
        setCertificadosStatus(statusObj);
        setCertificadosElegiveisPraEficacia(eficaciaObj);
    }, [dataCertificados, token]);

    // Função para verificar o status de expiração
    const verificarExpiracao = useCallback((certificadoId) => {
        if (certificadosStatus[certificadoId]) {
            setStatusExpiracao(certificadosStatus[certificadoId]);
        } else {
            setStatusExpiracao(null);
        }
    }, [certificadosStatus]);
    
    // Função para navegar para a avaliação de eficácia
    const navegarParaAvaliacaoEficacia = useCallback((certificadoId) => {
        navigate(`/avaliacao-eficacia/${certificadoId}`);
    }, [navigate]);

    // Função para visualizar os resultados da avaliação de eficácia
    const visualizarAvaliacaoEficacia = useCallback(async (certificadoId) => {
        try {
            const response = await Api.get(`/api/avaliacoes-eficacia-info/${certificadoId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            if (response.data.avaliacao_exists) {
                setAvaliacaoEficaciaDetalhes(response.data);
                setShowModalAvaliacaoEficacia(true);
            } else {
                setToast({ 
                    header: 'Atenção!', 
                    body: 'Não foi possível encontrar os detalhes da avaliação.' 
                });
                setShowToast(true);
            }
        } catch (error) {
            setToast({ 
                header: 'Erro!', 
                body: error.response?.data?.message || 'Erro ao buscar detalhes da avaliação de eficácia.' 
            });
            setShowToast(true);
        }
    }, [token]);

    // Gerar PDF
    const loadPDFData = useCallback(async (data) => {
        try {
            // Verificar se o certificado está expirado usando o status já carregado
            const statusCertificado = certificadosStatus[data];
            
            if (!statusCertificado) {
                setToast({
                    header: 'Erro!',
                    body: "Não foi possível verificar o status do certificado. Tente novamente."
                });
                setShowToast(true);
                return;
            }
            
            // Se o certificado está expirado e usuário não é Admin/Moderador, mostra mensagem e não permite download
            if ((statusCertificado.expirado || statusCertificado.arquivado) && !isAdminOrModerador) {
                let mensagem = "Este certificado não está mais válido.";
                
                if (statusCertificado.arquivado) {
                    mensagem = statusCertificado.message || "Este certificado foi arquivado devido ao reinício do curso.";
                } else if (statusCertificado.data_expiracao) {
                    mensagem = "Este certificado expirou. É necessário refazer o curso para obter um novo certificado.";
                }
                
                setToast({
                    header: 'Certificado expirado!',
                    body: mensagem
                });
                setShowToast(true);
                return;
            }
            
            // Se o certificado está expirado mas o usuário é Admin/Moderador, mostrar aviso mas permitir download
            if ((statusCertificado.expirado || statusCertificado.arquivado) && isAdminOrModerador) {
                let mensagem = "Este certificado ";
                
                if (statusCertificado.arquivado) {
                    mensagem += "foi arquivado";
                } else {
                    mensagem += "está expirado";
                }
                
                mensagem += ", mas você tem permissão para baixá-lo como " + nivelUsuario + ".";
                
                setToast({
                    header: 'Aviso!',
                    body: mensagem
                });
                setShowToast(true);
            }
            
            // Buscar os dados para gerar o PDF
            const response = await Api.get(`api/info-certificado/${data}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // Gerar o PDF e obter como Blob
            const blob = await pdf(
                <GerarCertificado 
                    data={{ 
                        id: response.data[0].id, 
                        nomeAluno: response.data[0].nomeAluno, 
                        codigo: response.data[0].codigo,
                        prazo_validade: response.data[0].prazo_validade, 
                        nomeCurso: response.data[0].nomeCurso, 
                        data: response.data[0].data, 
                        nomeGestor: response.data[0].nomeGestor, 
                        certificado: response.data[0].certificado, 
                        certificado_frente: response.data[0].certificado_frente,
                        nomeTopico: response.data[0].nomeTopico, 
                        cargaHorariaTotal: response.data[0].cargaHorariaTotal, 
                        unidade: response.data[0].unidade 
                    }} 
                    diplomaUrl={ajustes.diploma}
                    empresa={response.data[0].empresa_nome || ajustes.titulo}
                />
            ).toBlob();

            // Criar uma URL para o Blob e abrir em uma nova aba
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (error) {
            setToast({ header: 'Erro!', body: "Erro ao gerar o PDF. Tente novamente." });
            setShowToast(true);
        }
    }, [token, ajustes.diploma, ajustes.titulo, isAdminOrModerador, nivelUsuario, certificadosStatus]);

    // Função para exportar os resultados da avaliação para Excel
    const exportarAvaliacaoEficaciaExcel = useCallback(() => {
        if (!avaliacaoEficaciaDetalhes) return;

        // Dados do aluno e certificado para a planilha
        const certificadoData = {
            "Aluno": avaliacaoEficaciaDetalhes.certificado.nomeAluno,
            "Curso": avaliacaoEficaciaDetalhes.certificado.nomeCurso,
            "Data Emissão Certificado": new Date(avaliacaoEficaciaDetalhes.certificado.data).toLocaleDateString('pt-BR'),
            "Avaliado por": avaliacaoEficaciaDetalhes.avaliacao.nome_gestor,
            "Data Avaliação": new Date(avaliacaoEficaciaDetalhes.avaliacao.data_avaliacao).toLocaleDateString('pt-BR')
        };

        // Dados do gestor para a planilha
        const gestorData = {
            "Nome do Gestor": avaliacaoEficaciaDetalhes.avaliacao.nome_gestor,
            "ID do Gestor": avaliacaoEficaciaDetalhes.avaliacao.id_gestor,
            "Data da Avaliação": new Date(avaliacaoEficaciaDetalhes.avaliacao.data_avaliacao).toLocaleDateString('pt-BR', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        };

        // Buscar dados adicionais do gestor (opcional)
        Api.get(`/api/usuario/${avaliacaoEficaciaDetalhes.avaliacao.id_gestor}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            if (response.data) {
                // Adicionar mais dados do gestor se disponível
                const gestorCompleto = {
                    ...gestorData,
                    "Email": response.data.email || "Não disponível",
                    "Unidade": response.data.unidade || "Não disponível",
                    "Cargo": response.data.cargo || "Não disponível"
                };
                
                gerarExcel(certificadoData, gestorCompleto);
            } else {
                gerarExcel(certificadoData, gestorData);
            }
        }).catch(error => {
            // Se não conseguir obter dados adicionais, continua com os dados básicos
            console.warn("Não foi possível obter dados completos do gestor:", error);
            gerarExcel(certificadoData, gestorData);
        });

        // Função para gerar o Excel com os dados disponíveis
        const gerarExcel = (certData, gestData) => {
            // Dados das respostas para a planilha
            const respostasData = Object.entries(avaliacaoEficaciaDetalhes.avaliacao.respostas).map(([idQuestao, resposta]) => ({
                "Pergunta": resposta.questao,
                "Resposta": resposta.resposta
            }));

            // Cria uma nova planilha
            const workbook = XLSX.utils.book_new();
            
            // Adiciona planilha com dados do certificado
            const worksheetInfo = XLSX.utils.json_to_sheet([certData]);
            XLSX.utils.book_append_sheet(workbook, worksheetInfo, "Informações");
            
            // Adiciona planilha com dados do gestor
            const worksheetGestor = XLSX.utils.json_to_sheet([gestData]);
            XLSX.utils.book_append_sheet(workbook, worksheetGestor, "Gestor");
            
            // Adiciona planilha de respostas
            const worksheetRespostas = XLSX.utils.json_to_sheet(respostasData);
            XLSX.utils.book_append_sheet(workbook, worksheetRespostas, "Respostas");
            
            // Adiciona comentários, se houver
            if (avaliacaoEficaciaDetalhes.avaliacao.comentarios) {
                const comentariosData = [{
                    "Comentários": avaliacaoEficaciaDetalhes.avaliacao.comentarios
                }];
                const worksheetComentarios = XLSX.utils.json_to_sheet(comentariosData);
                XLSX.utils.book_append_sheet(workbook, worksheetComentarios, "Comentários");
            }
            
            // Gera o arquivo e realiza o download
            const nomeArquivo = `Avaliacao_Eficacia_${avaliacaoEficaciaDetalhes.certificado.nomeAluno.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, nomeArquivo);
            
            setToast({ 
                header: 'Sucesso!', 
                body: 'Relatório de avaliação de eficácia exportado com sucesso!' 
            });
            setShowToast(true);
        };
    }, [avaliacaoEficaciaDetalhes, setToast, setShowToast, token]);

    const columns = useMemo(
        () => [
            {
                Header: () => null, // Sem título para esta coluna
                id: 'foto',
                accessor: row => row.foto,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex align-items-center">
                        <div className="picture text-white bg-grey" style={{ fontSize: '22px', height: '42px', marginRight: '0px', width: '42px' }}>
                            {value ? <img className="object-fit-cover" src={`${process.env.REACT_APP_API_URL}/fotos/${value}`} alt="Profile" style={{ height: '42px', width: '42px' }} /> : <i className="bi bi-person-fill-check fs-3"></i>}
                        </div>
                    </div>
                )
            },
            {
                Header: () => null,
                accessor: 'nomeAluno',
                Cell: ({ cell: { value }, row: { original } }) => (
                    <>
                        <div className=''>{value}</div>
                        <div className='badge bg-primary'>{original.codigo}</div>
                        <div className='badge bg-success ms-1'>{original.unidade}</div>
                    </>
                )
            },
            {
                Header: () => null,
                accessor: 'empresa_nome',
                Cell: ({ cell: { value } }) => (
                    <div className="text-center">
                        <span className="badge bg-secondary">{value || 'Sem empresa'}</span>
                    </div>
                )
            },
            {
                Header: 'Curso',
                accessor: 'nomeCurso'
            },
            {
                Header: 'Gestor',
                accessor: row => row.nomeGestor,
                Cell: ({ value }) => (
                    value ? value : "Automático"
                )
            },
            {
                Header: () => null, // Sem título para esta coluna
                id: 'data',
                accessor: row => row.data,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="fs-7 text-center text-nowrap">
                        {formatDateTime(value)}
                    </div>
                )
            },
            {
                Header: () => 'Status',
                id: 'status',
                accessor: row => row.id,
                Cell: ({ cell: { value }, row: { original } }) => {
                    const status = certificadosStatus[value];
                    if (!status) return <div className="text-center">-</div>;
                    
                    if (status.prazo_validade === null || status.prazo_validade === 0) {
                        return (
                            <div className="text-center">
                                <span className="badge bg-info">Permanente</span>
                            </div>
                        );
                    }
                    
                    if (status.expirado) {
                        return (
                            <div className="text-center">
                                <span className="badge bg-danger">Expirado</span>
                                <div className="small text-muted">
                                    {status.arquivado ? 
                                        "" : 
                                        (status.data_expiracao ? new Date(status.data_expiracao).toLocaleDateString() : "Data não disponível")}
                                </div>
                            </div>
                        );
                    }
                    
                    return (
                        <div className="text-center">
                            <span className="badge bg-success">Válido</span>
                            <div className="small text-muted">
                                até {status.data_expiracao ? new Date(status.data_expiracao).toLocaleDateString() : "Data não disponível"}
                            </div>
                        </div>
                    );
                }
            },
            {
                Header: () => null,
                id: 'acoes',
                accessor: row => row.id,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="d-flex align-items-center justify-content-end gap-2">
                        <Tippy content="Baixar Certificado">
                            <button
                                onClick={() => {
                                    loadPDFData(original.id);
                                }}
                                className="btn btn-outline-primary text-primary rounded px-2"
                                disabled={!isAdminOrModerador && (certificadosStatus[value]?.expirado || certificadosStatus[value]?.arquivado)}
                            > 
                                <i className="bi bi-box-arrow-in-down"></i>
                            </button>
                        </Tippy>
                        <Tippy content="Ver Detalhes">
                            <button
                                onClick={() => {
                                    setCertificadoSelecionado(original);
                                    verificarExpiracao(original.id);
                                    setShowModalDetalhes(true);
                                }}
                                className="btn btn-outline-primary text-primary rounded px-2"
                            >
                                <i className="bi bi-eye"></i>
                            </button>
                        </Tippy>
                        {isAdminModeradorOrGestor && (
                            original.avaliacao_eficacia === 1 ? (
                                <Tippy content="Ver Avaliação de Eficácia">
                                    <button
                                        onClick={() => visualizarAvaliacaoEficacia(original.id)}
                                        className="btn btn-outline-success text-success rounded px-2"
                                    >
                                        <i className="bi bi-file-earmark-text"></i>
                                    </button>
                                </Tippy>
                            ) : (
                                isGestor && (
                                    <Tippy content={
                                        certificadosStatus[value]?.expirado || certificadosStatus[value]?.arquivado
                                            ? "Certificados expirados ou arquivados não podem ser avaliados."
                                            : !certificadosElegiveisPraEficacia[value]?.isGestorResponsavel
                                                ? "Você não é o gestor responsável por este aluno."
                                                : !certificadosElegiveisPraEficacia[value]?.elegivel 
                                                    ? "Certificado ainda não completou 90 dias para ser avaliado." 
                                                    : "Responder Avaliação de Eficácia"
                                    }>
                                        <button
                                            onClick={() => {
                                                if (certificadosElegiveisPraEficacia[value]?.elegivel) {
                                                    navegarParaAvaliacaoEficacia(original.id);
                                                }
                                            }}
                                            className={`btn btn-outline-${
                                                certificadosElegiveisPraEficacia[value]?.elegivel 
                                                    ? 'warning' 
                                                    : 'secondary'
                                            } rounded px-2`}
                                            disabled={!certificadosElegiveisPraEficacia[value]?.elegivel}
                                        >
                                            <i className={`bi bi-${
                                                certificadosElegiveisPraEficacia[value]?.elegivel 
                                                    ? 'stars' 
                                                    : 'slash-circle'
                                            }`}></i>
                                        </button>
                                    </Tippy>
                                )
                            )
                        )}
                    </div>
                )
            },
            {
                Header: 'Codigo',
                accessor: 'codigo',
                visible: false
            }
        ],
        [loadPDFData, verificarExpiracao, certificadosStatus, certificadosElegiveisPraEficacia, isAdminOrModerador, isGestor, isAdminModeradorOrGestor, navegarParaAvaliacaoEficacia, visualizarAvaliacaoEficacia]
    )

    return (
        <>
            <div className="fade-in w-100">
                <span className="text-primary fs-1">Certificados</span>
                <p className="fs-6">Lista com todos os certificados disponíveis</p>
                <TableCertificado 
                    columns={columns} 
                    data={FilterDataUnidade} 
                    filterSelect={dataTodosCursos} 
                    setSelectCurso={setSelectCurso} 
                    filterTipo={filterTipo} 
                    setSelectedTipo={setSelectedTipo} 
                    setSelectUnidade={setSelectUnidade} 
                    unidades={unidades}
                    empresas={isGestor ? [] : dataEmpresas}
                    selectedEmpresa={isGestor ? null : selectedEmpresa}
                    setSelectedEmpresa={isGestor ? null : setSelectedEmpresa}
                    titulo="Lista de Certificados" 
                />
            </div>

            <Modal size="lg" show={showModalDetalhes} onHide={() => setShowModalDetalhes(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Detalhes do Certificado</span>
                </Modal.Header>
                <Modal.Body>
                    {certificadoSelecionado && (
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="text-primary fw-medium">Aluno</label>
                                                <p className="mb-0">{certificadoSelecionado.nomeAluno}</p>
                                            </div>
                                            <div className="mb-3">
                                                <label className="text-primary fw-medium">Curso</label>
                                                <p className="mb-0">{certificadoSelecionado.nomeCurso}</p>
                                            </div>
                                            <div className="mb-3">
                                                <label className="text-primary fw-medium">Gestor</label>
                                                <p className="mb-0">{certificadoSelecionado.nomeGestor}</p>
                                            </div>
                                            <div className="mb-3">
                                                <label className="text-primary fw-medium">Data de Emissão</label>
                                                <p className="mb-0">{formatDateTime(certificadoSelecionado.data)}</p>
                                            </div>
                                            <div className="mb-3">
                                                <label className="text-primary fw-medium">Unidade</label>
                                                <p className="mb-0">{certificadoSelecionado.unidade}</p>
                                            </div>
                                            
                                            {statusExpiracao && (
                                                <div className="mb-3">
                                                    <label className="text-primary fw-medium">Status</label>
                                                    <div className="d-flex align-items-center">
                                                        {statusExpiracao.prazo_validade === null || statusExpiracao.prazo_validade === 0 || Number(statusExpiracao.prazo_validade) === 0 ? (
                                                            <>
                                                                <div className="badge bg-info me-2">Permanente</div>
                                                                <p className="mb-0 small">Este certificado não tem prazo de validade</p>
                                                            </>
                                                        ) : statusExpiracao.expirado ? (
                                                            <>
                                                                <div className="badge me-2 bg-danger">
                                                                    Expirado
                                                                </div>
                                                                <p className="mb-0 small">
                                                                    {statusExpiracao.arquivado ? 
                                                                        statusExpiracao.message || "" : 
                                                                        `Expirou em ${statusExpiracao.data_expiracao ? new Date(statusExpiracao.data_expiracao).toLocaleDateString() : "data não disponível"}`}
                                                                </p>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="badge me-2 bg-success">
                                                                    Válido
                                                                </div>
                                                                <p className="mb-0 small">
                                                                    Expira em {statusExpiracao.data_expiracao ? new Date(statusExpiracao.data_expiracao).toLocaleDateString() : "data não disponível"}
                                                                </p>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {isAdminModeradorOrGestor && certificadoSelecionado && (
                                                <div className="mb-3">
                                                    <label className="text-primary fw-medium">Avaliação de Eficácia</label>
                                                    <div className="d-flex align-items-center">
                                                        {certificadoSelecionado.avaliacao_eficacia === 1 ? (
                                                            <>
                                                                <div className="badge bg-success me-2">Respondida</div>
                                                                <p className="mb-0 small">Avaliação de eficácia já foi respondida</p>
                                                            </>
                                                        ) : statusExpiracao?.expirado || statusExpiracao?.arquivado ? (
                                                            <>
                                                                <div className="badge bg-secondary me-2">Não Aplicável</div>
                                                                <p className="mb-0 small">Certificados expirados ou arquivados não podem receber avaliação de eficácia</p>
                                                            </>
                                                        ) : isGestor && !certificadosElegiveisPraEficacia[certificadoSelecionado.id]?.isGestorResponsavel ? (
                                                            <>
                                                                <div className="badge bg-secondary me-2">Sem Permissão</div>
                                                                <p className="mb-0 small">Você não é o gestor responsável por este aluno</p>
                                                            </>
                                                        ) : isGestor && certificadosElegiveisPraEficacia[certificadoSelecionado.id]?.elegivel ? (
                                                            <>
                                                                <div className="badge bg-warning me-2">Pendente</div>
                                                                <p className="mb-0 small">Este certificado está elegível para avaliação de eficácia</p>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className="badge bg-secondary me-2">Não Elegível</div>
                                                                <p className="mb-0 small">O certificado precisa ter mais de 90 dias para ser avaliado</p>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <div className="d-flex justify-content-center gap-2">
                        <button 
                            className="btn btn-primary text-white px-4"
                            onClick={() => {
                                loadPDFData(certificadoSelecionado.id);
                            }}
                            disabled={!isAdminOrModerador && (statusExpiracao?.expirado || statusExpiracao?.arquivado)}
                        >
                            Baixar Certificado
                        </button>
                        {isAdminModeradorOrGestor && certificadoSelecionado && 
                          certificadoSelecionado.avaliacao_eficacia === 1 ? (
                            <button 
                                className="btn btn-success text-white px-4"
                                onClick={() => {
                                    setShowModalDetalhes(false);
                                    visualizarAvaliacaoEficacia(certificadoSelecionado.id);
                                }}
                            >
                                Ver Avaliação de Eficácia
                            </button>
                          ) : (isGestor && certificadoSelecionado && 
                             certificadosElegiveisPraEficacia[certificadoSelecionado.id]?.elegivel && 
                             certificadoSelecionado.avaliacao_eficacia !== 1 && 
                             !statusExpiracao?.expirado && 
                             !statusExpiracao?.arquivado) && (
                            <button 
                                className="btn btn-warning text-white px-4"
                                onClick={() => {
                                    setShowModalDetalhes(false);
                                    navegarParaAvaliacaoEficacia(certificadoSelecionado.id);
                                }}
                            >
                                Responder Avaliação de Eficácia
                            </button>
                          )
                        }
                        <button 
                            className="btn btn-outline-primary"
                            onClick={() => setShowModalDetalhes(false)}
                        >
                            Fechar
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size="lg" show={showModalAvaliacaoEficacia} onHide={() => setShowModalAvaliacaoEficacia(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Avaliação de Eficácia</span>
                </Modal.Header>
                <Modal.Body>
                    {avaliacaoEficaciaDetalhes && (
                        <div className="container">
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <h5 className="card-title text-primary mb-3">Informações Gerais</h5>
                                            <div className="mb-2">
                                                <strong>Aluno:</strong> {avaliacaoEficaciaDetalhes.certificado.nomeAluno}
                                            </div>
                                            <div className="mb-2">
                                                <strong>Curso:</strong> {avaliacaoEficaciaDetalhes.certificado.nomeCurso}
                                            </div>
                                            <div className="mb-2">
                                                <strong>Avaliado por:</strong> {avaliacaoEficaciaDetalhes.avaliacao.nome_gestor}
                                            </div>
                                            <div className="mb-2">
                                                <strong>Data da Avaliação:</strong> {new Date(avaliacaoEficaciaDetalhes.avaliacao.data_avaliacao).toLocaleDateString('pt-BR', { 
                                                    year: 'numeric', 
                                                    month: 'long', 
                                                    day: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit'
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body">
                                            <h5 className="card-title text-primary mb-3">Respostas</h5>
                                            <div className="table-responsive">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Pergunta</th>
                                                            <th className="text-end">Resposta</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(avaliacaoEficaciaDetalhes.avaliacao.respostas).map(([idQuestao, resposta], index) => (
                                                            <tr key={index}>
                                                                <td>{resposta.questao}</td>
                                                                <td className="text-end">
                                                                    <span className={`badge ${
                                                                        resposta.resposta.includes('Excelente') || resposta.resposta.includes('Muito Bom') ? 'bg-success' :
                                                                        resposta.resposta.includes('Satisfatório') ? 'bg-info' :
                                                                        resposta.resposta.includes('Regular') ? 'bg-warning' :
                                                                        resposta.resposta.includes('Insatisfatório') ? 'bg-danger' :
                                                                        resposta.resposta === 'Sim' ? 'bg-success' : 
                                                                        resposta.resposta === 'Não' ? 'bg-danger' : 'bg-secondary'
                                                                    }`}>
                                                                        {resposta.resposta}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            {avaliacaoEficaciaDetalhes.avaliacao.comentarios && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-body">
                                                <h5 className="card-title text-primary mb-3">Comentários Adicionais</h5>
                                                <p>{avaliacaoEficaciaDetalhes.avaliacao.comentarios}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button 
                        className="btn btn-success"
                        onClick={exportarAvaliacaoEficaciaExcel}
                    >
                        <i className="bi bi-file-excel me-2"></i>
                        Exportar Excel
                    </button>
                    <button className="btn btn-outline-primary" onClick={() => setShowModalAvaliacaoEficacia(false)}>
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>

            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>
        </>
    )
}

export default Certificados;